export default __webpack_public_path__ + "static/media/db_minor.b926ff62.jpg";